import Vue from 'vue';
import moment from 'moment';

function _getTimeFormatted(value, format, timezone = 'Z') {
  return value ? moment(String(value) + timezone).format(format) : undefined;
}

/**
 * Date time common filters
 */

Vue.filter('dateSmall', value => _getTimeFormatted(value, 'DD/MM'));

Vue.filter('date', value => _getTimeFormatted(value, 'DD/MM/YYYY'));

Vue.filter('dateTime', value => _getTimeFormatted(value, 'DD/MM/YYYY HH:mm'));

Vue.filter('dateTimeExtended', value => _getTimeFormatted(value, '[il] DD/MM/YYYY [alle] HH:mm'));

Vue.filter('dateTimeExtendedLT', value => _getTimeFormatted(value, '[il] DD/MM/YYYY [alle] HH:mm', ''));

Vue.filter('time', value => _getTimeFormatted(value, 'HH:mm'));
